<template>
  <div>
    <Chart :options="chartOptions"></Chart>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import more from "highcharts/highcharts-more";
import { computed, toRefs } from "vue";
more(Highcharts);

export default {
  components: { Chart },
  props: {
    labels: {
      type: Array,
      default: () => [],
    },
    series: {
      type: Array,
      default: () => [],
    },
    titleText: {
      type: String,
      default: "",
    },
    colors: {
      type: Array,
      default: () => ["#0085FF", "#FDAB3D"],
    },
    width: {
      type: [Number, String],
      default: "",
    },
    height: {
      type: [Number, String],
      default: "",
    },
    xAxisLabels: {
      type: Boolean,
      default: true,
    },
    yAxisLabels: {
      type: Boolean,
      default: true,
    },
    yAxisMax: {
      type: Number,
      default: 3,
    },
    backgroundColor: {
      type: String,
      default: "#fff",
    },
    columnPointWidth: {
      type: [Number, String],
      default: 40,
    },
    isEnabledLegend: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    // generate props data
    const {
      labels,
      series,
      titleText,
      colors,
      width,
      height,
      xAxisLabels,
      yAxisLabels,
      yAxisMax,
      backgroundColor,
      columnPointWidth,
      isEnabledLegend,
    } = toRefs(props);

    const chartOptions = computed(() => {
      const options = {
        chart: {
          style: {
            fontFamily: "iranyekan",
          },
          zoomType: "xy",
          backgroundColor: backgroundColor.value,
        },
        colors: colors.value,
        title: {
          text: titleText.value,
          align: "right",
        },
        subtitle: {
          text: "",
          align: "right",
        },
        xAxis: {
          categories: labels.value,
          labels: {
            enabled: xAxisLabels.value,
          },
          title: {
            text: null,
            enabled: false,
          },
        },
        yAxis: [
          {
            // Primary yAxis
            labels: {
              format: "",
              enabled: yAxisLabels.value,
            },
            title: {
              text: "",
            },
            max: yAxisMax.value,
          },
          {
            // Secondary yAxis
            title: {
              text: "",
            },
            labels: {
              format: "",
              enabled: false,
            },
          },
        ],
        tooltip: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: false,
            },
            pointWidth: 40, // set the width of the columns
          },
          column: {
            dataLabels: {
              enabled: false,
            },
            pointWidth: columnPointWidth.value, // set the width of the columns
          },
        },
        legend: {
          enabled: isEnabledLegend.value,
        },
        series: series.value,
      };

      if (width.value) {
        options.chart = { ...options.chart, width: width.value };
      }
      if (height.value) {
        options.chart = { ...options.chart, height: height.value };
      }

      return options;
    });

    // return data to be used in template
    return { chartOptions };
  },
};
</script>
